import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { UtilityService } from './utility.service';

@Injectable({
  providedIn: 'root'
})
export class TimeTrackerService {
  private timer$: Subscription | undefined;
  public url: string;
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string, @Inject('IDENTITYSERVER_URL') identityBaseUrl: string, public utility: UtilityService) {

    this.url = this.utility.removeSlashFromUrlAtEnd(identityBaseUrl);
  }

  startTracking() {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
    
    this.timer$ = interval(10000).subscribe(() => {
      let moduleName = localStorage.getItem('serviceName');

      this.http.post(`${this.url}/Account/UpdateTimeSpent`, {
        userId: user.id.toString(),
        module: moduleName  // <-- send the module name
      })
        .subscribe({
          next: (res) => console.log('Updated:', res),
          error: (err) => console.error(err)
        });
    });
  }
  stopTracking() {
    this.timer$?.unsubscribe();
  }

}
